// NotificationList.js
import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { notifications_change_status, scheduleAcceptOrReject } from '../../../../config/Notifications/notifications';
import { fetchNotificationsList, getNavigationPath } from '../../../../utils/notification';
import { useDispatch } from 'react-redux';
import NotificationActionButtons from '../NotifActionButtons/NotificationActionButtons';
import CustomConfirmationView from '../../../CustomConfirmationView/CustomConfirmationView';
import CustomModal from '../../../custom_components/CustomModal/CustomModal';
const MotionBox = motion(Box);

const NotificationList = ({ notifications = [], handleClose }) => {

  // --- State for confirmation modal ---
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNotif, setSelectedNotif] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null); // 1 = accept, 2 = reject


  const navigate = useNavigate()
  const dispatch = useDispatch()

  const readNotifications = async (params, info) => {
    const path = getNavigationPath(info); // FOR GET PATH TO NAVIGATE

    try {
      const response = await notifications_change_status(params);
      if (response?.status !== "success") {
        console.error("Notification read failed.");
      }
    } catch (err) {
      console.error("Error reading notification:", err);
    } finally {
      fetchNotificationsList(dispatch); //FOR UPDATE NOTIFICATION AFTER READ THE NOTIFICATION
      navigate(path);     // Always navigate 
      handleClose();      //  close modal
    }
  };

  // FOR NAVIGATE HANDLING
  const handleNavigation = (info) => {
    const params = {
      notificationID: info?.ND_Id,
    };
    readNotifications(params, info);
  };


  // --- Trigger Accept/Reject confirmation modal ---
  const handleScheduleActionClick = (notif, actionType) => {
    setSelectedNotif(notif);
    setSelectedAction(actionType);
    setIsModalOpen(true);
  };

  // --- Confirm Accept/Reject action ---
  const handleScheduleActionConfirm = async () => {

    if (!selectedNotif) return;
    try {
      const params = {
        notificationId: selectedNotif?.ND_Id,
        scheduleId: selectedNotif?.ND_scheduleID,
        is_accept: selectedAction,
      };

      const response = await scheduleAcceptOrReject(params);
      if (response?.status === 'success') {
        const readParams = { notificationID: selectedNotif?.ND_Id };
        await readNotifications(readParams, selectedNotif);
      } else {
        console.error('Schedule action failed:', response);
      }
    } catch (err) {
      console.error('Error handling schedule action:', err);
    } finally {
      setIsModalOpen(false);
      setSelectedNotif(null);
      setSelectedAction(null);
    }
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setSelectedNotif(null);
    setSelectedAction(null);
  };

  return (

    <Box
      sx={{
        // maxHeight: '37vh',
        overflowY: 'auto',
        mt: 2,
        borderRadius: 2,
        p: 1,
      }}
    >
      {notifications?.length === 0 ? (
        <Typography variant="body1" color="text.secondary" align="center" mt={3}>
          No Notifications!
        </Typography>
      ) : (
        notifications.map((notif, index) => (
          <MotionBox
            key={notif.ND_Id}
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ delay: index * 0.05, duration: 0.3 }}
            sx={{
              position: 'relative',
              p: 2,
              mb: 1,
              borderRadius: 2,
              border: '1px solid #567C09',
              backgroundColor: notif.ND_is_read ? '#f9f9f9' : '#e8f5e9',
            }}
          >
            {!notif.ND_is_read && (
              <FiberManualRecordIcon
                sx={{
                  fontSize: 12,
                  color: 'green',
                  position: 'absolute',
                  top: 16,
                  right: 16,
                }}
              />
            )}

            <Typography
              fontWeight={notif.ND_is_read ? 500 : 700}
              color="primary"
              gutterBottom
            >
              {notif.ND_Sender} - {notif.ND_TypeName}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography
                title={notif.ND_Message}
                sx={{
                  fontSize: '0.9rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '70%',
                  color: '#1E293B',
                }}
              >
                {notif?.ND_Message}
              </Typography>



              <Typography sx={{ fontSize: '0.8rem', color: '#888' }}>
                {notif.ND_created_at}
              </Typography>
            </Box>

            {/* Action Buttons */}
            <NotificationActionButtons
              notif={notif}
              onAccept={(n) => handleScheduleActionClick(n, 1)}
              onReject={(n) => handleScheduleActionClick(n, 2)}
              onView={(n) => handleNavigation(n)}
            />
          </MotionBox>
        ))
      )}

      {/* 🔹 Confirmation Modal */}
      {isModalOpen && <CustomModal
        open={isModalOpen}
        title={selectedAction === 1 ? 'Accept Schedule' : 'Reject Schedule'}
        handleClose={handleModalCancel}
        body={
          <CustomConfirmationView
            message={`Are you sure you want to ${selectedAction === 1 ? 'accept' : 'reject'
              } this schedule?`}
            onConfirm={handleScheduleActionConfirm}
            onCancel={handleModalCancel}
            confirmLabel={selectedAction === 1 ? 'Accept' : 'Reject'}
            cancelLabel="Back"
          />
        }
        maxWidth="500px"
      />}
    </Box>

  );
};

export default NotificationList;
